import React, { useContext, useState as classicUseState } from 'react';
import { useState } from '@hookstate/core';
import { Icon as BlueIcon } from '@blueprintjs/core';

import { DeleteDialog } from '@components';

import { deletePicture } from '@services/queries/pictures/deletePictures/deletePictures';
import { useMutation, useQueryClient } from 'react-query';
import { useParams } from 'react-router-dom';
import { IPicture } from '@models/Picture.model';
import { useSelector } from 'react-redux';
import { checkDevice } from '@store/redux/features/mobile/mobileSelectors';
import { AssetContext } from '@pages/Asset/Asset.query';
import { Container, Close, Header, Title } from './MenuContent.styles';
import { PicturesEdit } from '../../../../../PicturesEdit/PicturesEdit';
import { MenuItemProps, MenuItem } from './MenuItemProps';

interface IMenuContent {
  picture: IPicture | undefined;
  setSelectedPicture: React.Dispatch<React.SetStateAction<string>>;
  selectedPicture: string;
  data: IPicture[];
  setOpenMenu: (bool: boolean) => void;
  setShow: React.Dispatch<React.SetStateAction<boolean>>;
}

const MenuContent = ({
  picture,
  selectedPicture,
  data,
  setSelectedPicture,
  setOpenMenu,
  setShow,
}: IMenuContent) => {
  const queryClient = useQueryClient();
  const params = useParams<{ equipmentId: string }>();

  const [showEdit, setShowEdit] = classicUseState<boolean>(false);
  const { setShowAdd } = useContext(AssetContext);
  const openDeleteDialog = useState(false);

  const mutationDeletePicture = useMutation(deletePicture, {
    onSuccess: () => {
      queryClient.invalidateQueries([
        'equipments',
        params.equipmentId,
        'pictures',
      ]);
      if (data.length === 1) {
        setShow(false);
        setSelectedPicture('');
      } else {
        setSelectedPicture(data?.filter(p => p.id !== selectedPicture)[0].id);
      }

      openDeleteDialog.set(false);
    },
  });
  const { isMobile } = useSelector(checkDevice());

  function getItems() {
    const addItem: MenuItemProps = {
      onClick: () => {
        setShowAdd(true);
      },
      label: 'Add',
      icon: 'plus',
    };
    const editItem: MenuItemProps = {
      onClick: () => {
        setShowEdit(true);
      },
      label: 'Edit Photo',
      icon: 'edit',
    };
    const deleteItem: MenuItemProps = {
      onClick: () => {
        openDeleteDialog.set(true);
      },
      label: 'Delete Picture',
      icon: 'trash',
    };
    if (isMobile) return [addItem, editItem, deleteItem];
    return [editItem, deleteItem];
  }
  return (
    <Container>
      <Header>
        <Title>Options</Title>
        <Close
          onClick={() => {
            setOpenMenu(false);
          }}
        >
          <BlueIcon icon="cross" color="#8F95B2" />
        </Close>
      </Header>
      {getItems().map(item => (
        <MenuItem {...item} />
      ))}

      {/* <Item
        onClick={() => {
          setShowEdit(true);
        }}
      >
        <Icon src={EditImg} alt="EditIcon" />
        <Label>Edit Photo</Label>
      </Item> */}
      {/* <Item
        onClick={() => {
          openDeleteDialog.set(true);
        }}
      >
        <Icon src={trashImg} alt="DeletIcon" />
        <Label>Delete Picture</Label>
      </Item> */}

      <DeleteDialog
        width="min(100%, 379px)"
        open={openDeleteDialog}
        onDelete={() => {
          if (selectedPicture && picture)
            mutationDeletePicture.mutate(picture.id);
          !mutationDeletePicture.isLoading && setOpenMenu(false);
        }}
      />
      {showEdit && !!picture && (
        <PicturesEdit
          setShowEdit={setShowEdit}
          picture={picture}
          setOpenMenu={setOpenMenu}
        />
      )}
    </Container>
  );
};

export { MenuContent };
